import { addDays, isAfter, isValid, parseISO } from 'date-fns';

export const isBonusIssuedAfterDays = (
  bonusDate: string | undefined,
  issuedAfterDays: number
) => {
  if (!bonusDate) return false;

  const parsedDate = parseISO(bonusDate);

  if (!isValid(parsedDate)) return false;

  return isAfter(new Date(), addDays(parsedDate, issuedAfterDays));
};
